<script setup lang="ts">
import MenuLink from '@app/layout/nav/mobile/components/MenuLink.vue';
import { URL_SEARCH, URL_USER_INBOX, URL_USER_PROPOSAL } from '@tools/routes/routes';
import { trans } from '@tools/translation.ts';
import { IconMagnifyingGlass, IconEnvelope, IconHeartStraight } from '@icons';
import Icon from '@components/Icon.vue';
import { storeToRefs } from 'pinia';
import { useNavbarStore } from '@stores/layout/useNavbarStore';

const { notifications } = storeToRefs(useNavbarStore());
</script>

<template>
  <li>
    <MenuLink :link="URL_SEARCH">
      <template #icon="{ isActive }">
        <Icon
          :svg="IconMagnifyingGlass"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.search') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <MenuLink
      :link="URL_USER_INBOX"
      :has-pin="notifications.unread_messages > 0"
      data-cy-ref="navbar-mobile__link--inbox"
    >
      <template #icon="{ isActive }">
        <Icon
          :svg="IconEnvelope"
          width="24"
          height="24"
          :stroke="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.inbox') }}
      </template>
    </MenuLink>
  </li>

  <li>
    <MenuLink
      :link="URL_USER_PROPOSAL"
      :has-pin="notifications.unread_match_proposal > 0"
    >
      <template #icon="{ isActive }">
        <Icon
          :svg="IconHeartStraight"
          width="24"
          height="24"
          :fill="isActive ? 'blue' : 'gray-darker'"
        />
      </template>

      <template #text>
        {{ trans('user_menu.selection_item') }}
      </template>
    </MenuLink>
  </li>
</template>
